export const updateProperty = (condition, valueIfTrue, valueIfFalse) => {
    return condition ? valueIfTrue : valueIfFalse
}
